const adminDashboardPath = '/admin-dashboard'
const eligibleEmployeeDashboardPath = '/eligible-employee-dashboard'
const csiDashboardPath = '/csi-dashboard'
const docReviewDashboardPath = '/doc-review-dashboard'
const ichraDecisionToolPath = '/ichra-decision-tool'
const nonEligibleEmployeeDashboardPath = '/non-eligible-employee-dashboard'

export const ROUTE_PATHS = {
  SIGNUP_PATH: '/signup',
  PASSWORD_RESET_REQUIRED_PATH: '/password-reset-required',
  LOGIN_PATH: '/login',
  FORGOT_PASSWORD_PATH: '/forgot-password',
  ADMIN_SIGNUP_PATH: '/signup-flow',
  ELIGIBLE_EMPLOYEE_CREATE_ACCOUNT: '/ee-signup',
  ELIGIBLE_EMPLOYEE_NOTICE: '/ee-notice',
  DASHBOARD_PATH: '/',
  MANAGE_PEOPLE: `${adminDashboardPath}/manage-people`,
  IMPORT_USERS: `import-users`,
  ADMIN_DASHBOARD_PATH: adminDashboardPath,
  ACTION_NEEDED: `${adminDashboardPath}/action-needed`,
  BENEFIT_DETAILS_PATH: `${adminDashboardPath}/benefit-details`,
  DESIGN_BENEFIT_PATH: `${adminDashboardPath}/benefit-details/design`,
  ELIGIBLE_EMPLOYEE_DASHBOARD: eligibleEmployeeDashboardPath,
  ELIGIBLE_EMPLOYEE_GET_REIMBURSED: `${eligibleEmployeeDashboardPath}/get-reimbursed`,
  ELIGIBLE_EMPLOYEE_TAX_SAVINGS: `${eligibleEmployeeDashboardPath}/tax-savings`,
  ELIGIBLE_EMPLOYEE_HSA_STATUS: `${eligibleEmployeeDashboardPath}/hsa-status`,
  ELIGIBLE_EMPLOYEE_COVERED_DEPENDENTS: `${eligibleEmployeeDashboardPath}/covered-dependents`,
  ELIGIBLE_EMPLOYEE_PROFILE: `${eligibleEmployeeDashboardPath}/my-profile`,
  ELIGIBLE_EMPLOYEE_SUBMIT_EXPENSE: `${eligibleEmployeeDashboardPath}/get-reimbursed/submit`,
  ELIGIBLE_EMPLOYEE_EDIT_PREMIUM_EXPENSE: `${eligibleEmployeeDashboardPath}/edit-premium-expense`,
  NON_ELIGIBLE_EMPLOYEE_DASHBOARD: nonEligibleEmployeeDashboardPath,
  REIMBURSEMENTS: `${adminDashboardPath}/reimbursements`,
  ADMIN_PROFILE: `${adminDashboardPath}/my-profile`,
  LEGAL_DOCUMENTS: `${adminDashboardPath}/legal-documents`,
  LEGAL_DOCUMENTS_SIGN_DOCUMENTS: `${adminDashboardPath}/legal-documents/sign-documents`,
  COMPANY_SETTINGS: `${adminDashboardPath}/company-settings`,
  RENEWAL_TASKS: `${adminDashboardPath}/renewal-tasks`,
  ASSIGN_CLASSES: `${adminDashboardPath}/assign-classes`,
  CHOOSE_APP: '/choose-app',
  ELIGIBLE_EMPLOYEE_SIGNUP_FLOW: '/ee-signup-flow',
  NON_ELIGIBLE_EMPLOYEE_SIGNUP: '/non-ee-signup',
  NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW: '/non-ee-signup-flow',
  DOC_REVIEW_DASHBOARD_PATH: '/doc-review-dashboard',
  CSI_DASHBOARD_PATH: csiDashboardPath,
  ICHRA_DECISION_TOOL_PATH: ichraDecisionToolPath,
  DOC_REVIEW_PATH: docReviewDashboardPath,
  ELIGIBLE_EMPLOYEE_CHANGE_PASSWORD: `${eligibleEmployeeDashboardPath}/change-password`,
  ADMIN_CHANGE_PASSWORD: `${adminDashboardPath}/change-password`,
  CSI_CHANGE_PASSWORD: `${csiDashboardPath}/change-password`,
  DOC_REVIEW_CHANGE_PASSWORD_PATH: `${docReviewDashboardPath}/change-password`,
  ICHRA_DECISION_TOOL_CHANGE_PASSWORD_PATH: `${ichraDecisionToolPath}/change-password`,
  NON_ELIGIBLE_EMPLOYEE__CHANGE_PASSWORD_PATH: `${nonEligibleEmployeeDashboardPath}/change-password`,
  NON_ELIGIBLE_EMPLOYEE_PROFILE: `${nonEligibleEmployeeDashboardPath}/my-profile`,
  CSI_SEARCH: `${csiDashboardPath}/csi-search`,
  CSI_COMPANY_DETAILS: `${csiDashboardPath}/csi-search/company-details`,
  CSI_QA_UTILS: `${csiDashboardPath}/qa-utils`,
  DOC_REVIEW_PREMIUMS: `${docReviewDashboardPath}/premiums`,
  DOC_REVIEW_EXPENSES: `${docReviewDashboardPath}/expenses`,
  DOC_REVIEW_SEARCH_PREMIUMS: `${docReviewDashboardPath}/search-premiums`,
  CSI_MARKETPLACE: `${csiDashboardPath}/marketplace`,
  OUR_PRODUCTS: `${adminDashboardPath}/our-products`,
  REPORTS: `${adminDashboardPath}/reports`,
  MESSAGES: `${adminDashboardPath}/messages`,
  CSI_CONFIGURATIONS: `${csiDashboardPath}/configurations`,
  CSI_EXPENSE_TYPES: `${csiDashboardPath}/expense-types`,
  PROSPECTS_PATH: 'prospects',
  PROPOSAL_PATH: 'start-proposal',
  PROSPECT_ANALYSIS_PATH: 'download-analysis',
  PROSPECT_WELCOME_PATH: 'welcome',
  UPLOAD_EMPLOYEE_CENSUS_PATH: 'upload-employee-census',
  EMAIL_TEMPLATES: `${csiDashboardPath}/email-templates`,
  ADD_EMAIL_TEMPLATES: `${csiDashboardPath}/email-templates/add-email-template`,
  EDIT_EMAIL_TEMPLATES: `${csiDashboardPath}/email-templates/edit-email-template`,
}
